const API_BASE = process.env.REACT_APP_TENANT_API || 'https://htb4wmezrg.execute-api.us-west-2.amazonaws.com/prod';

// MSP Management
export const getAllMSPs = async () => {
  const response = await fetch(`${API_BASE}/v2/admin/msps`);
  if (!response.ok) {
    throw new Error('Failed to fetch MSPs');
  }
  const data = await response.json();
  return data.msps || [];
};

export const getMSPDetails = async (mspID) => {
  const response = await fetch(`${API_BASE}/v2/msp/settings?mspID=${mspID}`);
  if (!response.ok) {
    throw new Error('Failed to fetch MSP details');
  }
  return response.json();
};

// Tenant Management for MSPs
export const createTenantForMSP = async (mspID, customerEmail, customerName) => {
  const response = await fetch(`${API_BASE}/v2/msp/tenants/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mspID, customerEmail, customerName })
  });
  if (!response.ok) {
    throw new Error('Failed to create tenant for MSP');
  }
  return response.json();
};

export const assignTenantToMSP = async (mspID, tenantID) => {
  const response = await fetch(`${API_BASE}/v2/msp/tenants/assign`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mspID, tenantID })
  });
  if (!response.ok) {
    throw new Error('Failed to assign tenant to MSP');
  }
  return response.json();
};

export const getMSPTenants = async (mspID) => {
  const response = await fetch(`${API_BASE}/v2/msp/tenants?mspID=${mspID}`);
  if (!response.ok) {
    throw new Error('Failed to fetch MSP tenants');
  }
  return response.json();
};

// Get all tenants (for assignment)
export const getAllTenants = async () => {
  const response = await fetch(`${API_BASE}/v2/admin/tenants`);
  if (!response.ok) {
    throw new Error('Failed to fetch all tenants');
  }
  const data = await response.json();
  return data.tenants || [];
};